import type {
  GeetestOptions,
  PluginLoaderOptions,
  QacaptchaOptions,
  RecaptchaOptions,
} from '../typings';
import { Geetest } from './geetest';
import { Qqcaptcha } from './qqcaptcha';
import { Recaptcha } from './recaptcha';

export class PluginLoader {
  options: PluginLoaderOptions;
  plugins: any[];

  constructor(options: PluginLoaderOptions) {
    this.plugins = [];
    this.options = options;

    const { plugins = [], ...rest } = options;

    plugins.forEach((name: string) => {
      if (name === 'geecaptcha') {
        this.plugins.push(new Geetest(rest as GeetestOptions));
      }
      if (name === 'qqcaptcha') {
        this.plugins.push(new Qqcaptcha(rest as QacaptchaOptions));
      }
      if (name === 'recaptcha') {
        this.plugins.push(new Recaptcha(rest as RecaptchaOptions));
      }
    });
  }
}
